import NavButton from '../Nav.button/Nav.button';
import { gsap } from 'gsap';

const NavigationAccordion = {
	el: {},

	init: function() {
		this.el = $('[component="Navigation"]');
		if (!this.el.length) return;
		this.folders = this.el.find('li.hasChildren');
		this.prepare();
		this.bind();
		NavButton.init($('[component="Header"]'));
	},

	prepare() {
		this.folders.each((i, el) => {
			const a = $(el).find('> a');
			const label = a.wrap('<span class="label"></span>');
			$(el).find('.label').append('<div class="icon" icon="add"></div>');

			$(el).not('.selected').find('> ul').css({ height: 0 });
		})
	},

	bind() {
		this.folders.find('.icon').click((evt) => {
			evt.stopPropagation();
			const el = $(evt.currentTarget.closest('li'));
			if (el.is('.selected')) this.collapse(el);
			else this.expand(el);
		});
	},

	show() {
		this.el.addClass('open');
		if (window.innerWidth < 1000)
			$('body').css({ 'overflow': 'hidden' });
	},

	hide() {
		this.el.removeClass('open');
		if (window.innerWidth < 1000)
			$('body').css('overflow', '');
	},

	expand(el) {
		let selected = el.siblings('.selected');
		if(!selected.length && el.closest('ul').is('[level="0"]')){
			selected = el.closest('nav').find('.selected');
		}
		if (selected.length) this.collapse(selected);

		el.addClass('selected');
		const ul = el.find('> ul');
		gsap.set(ul, { height: 'auto' });
		gsap.from(ul, { height: 0, clearProps: 'all', duration: 0.3, ease: 'power2.out' });
	},

	collapse(el) {
		el.removeClass('selected');
		const ul = el.find('> ul');
		gsap.to(ul, {
			height: 0, onComplete: () => {
				// el.removeClass('selected');
			},
		});
	},

};

export default NavigationAccordion;
window.NavigationMain = NavigationAccordion;